import React from "react"
import Select, { SingleValue, StylesConfig } from "react-select"

const customStyles: StylesConfig<{ value: string; label: string }, false> = {
  clearIndicator: (provided) => ({
    ...provided,
    "&:hover": {
      color: "#90C4E0",
      cursor: "pointer",
      opacity: 1,
    },
    color: "#90C4E0",
    opacity: 0.7,
  }),
  control: (provided) => ({
    ...provided,
    "&:focus": {
      borderColor: "#90C4E0",
    },
    "&:hover": {
      borderColor: "#90C4E0",
    },
    backgroundColor: "#F8FDFF",
    borderColor: "#90C4E0",
    borderRadius: "12px",
    boxShadow: "none",
    cursor: "text",
    marginBottom: "8px",
    padding: "2px",
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    display: "none",
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: "#F8FDFF",
    border: "1px solid #90C4E0",
    borderRadius: "8px",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
    marginTop: "0px",
    overflow: "hidden",
  }),
  menuList: (provided) => ({
    ...provided,
    padding: "0px",
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused ? "rgba(139, 139, 139, 0.3)" : "#F8FDFF",
    color: "#032F47",
    cursor: "pointer",
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#90C4E0",
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#032F47",
  }),
}

interface DropdownInputProps {
  options: { value: string; label: string }[];
  value: { value: string; label: string } | null;
  onChange: (selectedOption: SingleValue<{ value: string; label: string }>) => void;
  placeholder: string;
  isClearable?: boolean;
}

const DropdownInput: React.FC<DropdownInputProps> = ({
  options,
  value,
  onChange,
  placeholder,
  isClearable = true,
}) => (
    <Select
      options={options}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      isClearable={isClearable}
      styles={customStyles}
    />
  )

export default DropdownInput
